<template>
  <div class="e-textarea">
    <RichContent :content="data.content.html"></RichContent>
  </div>
</template>
<script>
import RichContent from '@/components/event/RichContent'
export default {
  name: 'e-textarea',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    RichContent
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

@media screen and (max-width: 768px) {
  .e-textarea {
    padding: 0 20px;
  }
}
</style>
